import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="horizontal-alignment-bottom"><path d="M3.75 20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 7.75V17.25H17.25V7.75H13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 3.75V17.25H10.25V3.75H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHorizontalAlignmentBottom;
